import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

import { TrajetService } from 'src/app/core/services/trajet.service';
import { MessageService } from 'src/app/core/services/message.service';
import { ToastService } from 'src/app/core/services/toast.service';
import { ZoneService } from 'src/app/core/services/zone.service';

@Component({
  selector: 'app-trajet',
  templateUrl: './trajet.component.html',
  styleUrls: ['./trajet.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TrajetComponent implements OnInit {

  trajetZonesForm!: FormGroup;
  trajetId: number | null = null;
  estModeEdition = false;

  textHeading = 'Zones';
  textBody = 'Trajet entre Zones';
  chargement = false;

  zonesOptions: any[] = [];
  zonesDepartFiltered: any[] = [];
  zonesDestinationFiltered: any[] = [];
  searchDepart: string = '';
  searchDestination: string = '';
  showDepartDropdown: boolean = false;
  showDestinationDropdown: boolean = false;

  constructor(
    private fb: FormBuilder,
    public trajetZonesService: TrajetService,
    private messageService: MessageService,
    private toastService: ToastService,
    private router: Router,
    private route: ActivatedRoute,
    private zoneService: ZoneService
  ) { 
    this.trajetZonesForm = this.fb.group({
      id: [null],
      zoneDepartId: [null, Validators.required],
      zoneDepartNom: ['', Validators.required],
      zoneDestinationId: [null, Validators.required],
      zoneDestinationNom: ['', Validators.required],
      distanceKm: [null, Validators.required],
      observations: ['']
    });
  }

  ngOnInit(): void {
    this.chargerZonesOptions();
    this.route.params.subscribe(params => {
      if (params['id']) {
        this.trajetId = +params['id'];
        this.estModeEdition = false;
        this.textBody = 'Afficher un Trajet';
        this.chargerTrajet(this.trajetId);
      }
    });
  }

  chargerTrajet(id: number): void {
    this.chargement = true;
    this.trajetZonesService.obtenirTrajetParId(id).subscribe(
      (trajet) => {
        this.chargement = false;
        this.trajetZonesForm.patchValue({
          id: trajet.id,
          zoneDepartId: trajet.zoneDepartId,
          zoneDepartNom: trajet.zoneDepartNom || trajet.zoneDepart?.nom,
          zoneDestinationId: trajet.zoneDestinationId,
          zoneDestinationNom: trajet.zoneDestinationNom || trajet.zoneDestination?.nom,
          distanceKm: trajet.distanceKm,
          observations: trajet.observations
        });
      },
      () => {
        this.chargement = false;
        this.toastService.erreur('Impossible de charger le trajet');
      }
    );
  }

  chargerZonesOptions() {
    this.zoneService.obtenirToutesLesZones(500).subscribe({
      next: (zones) => {
        this.zonesOptions = zones || [];
        this.zonesDepartFiltered = [...this.zonesOptions];
        this.zonesDestinationFiltered = [...this.zonesOptions];
      },
      error: () => {
        this.toastService.erreur('Impossible de charger les zones');
      }
    });
  }

  toggleDropdown(type: 'depart' | 'destination') {
    if (type === 'depart') {
      this.showDepartDropdown = !this.showDepartDropdown;
      this.showDestinationDropdown = false;
      if (this.showDepartDropdown) this.filterZones('depart');
    } else {
      this.showDestinationDropdown = !this.showDestinationDropdown;
      this.showDepartDropdown = false;
      if (this.showDestinationDropdown) this.filterZones('destination');
    }
  }

  selectZone(type: 'depart' | 'destination', zone: any) {
    const prefix = type === 'depart' ? 'zoneDepart' : 'zoneDestination';
    this.trajetZonesForm.patchValue({
      [`${prefix}Id`]: zone.id,
      [`${prefix}Nom`]: zone.nom
    });

    if (type === 'depart') {
      this.showDepartDropdown = false;
      this.searchDepart = '';
      this.filterZones('destination'); // mettre à jour la liste destination (exclure ce départ)
    } else {
      this.showDestinationDropdown = false;
      this.searchDestination = '';
      this.filterZones('depart'); // mettre à jour la liste départ (exclure cette destination)
    }
    this.filterZones(type);
  }

  filterZones(type: 'depart' | 'destination') {
    const term = (type === 'depart' ? this.searchDepart : this.searchDestination).toLowerCase().trim();
    let filtered = this.zonesOptions.filter(z => {
      const nomMatch = z.nom ? z.nom.toLowerCase().includes(term) : false;
      const descMatch = z.description ? z.description.toLowerCase().includes(term) : false;
      return term === '' ? true : (nomMatch || descMatch);
    });
    if (type === 'depart') {
      const destId = this.trajetZonesForm.value?.zoneDestinationId;
      if (destId != null) filtered = filtered.filter(z => z.id !== destId);
      this.zonesDepartFiltered = filtered;
    } else {
      const departId = this.trajetZonesForm.value?.zoneDepartId;
      if (departId != null) filtered = filtered.filter(z => z.id !== departId);
      this.zonesDestinationFiltered = filtered;
    }
  }


  onSubmit() {
    if (this.trajetZonesForm.invalid) {
      this.trajetZonesForm.markAllAsTouched();
      this.toastService.erreur("Veuillez renseigner la zone de départ, la zone d'arrivée et la distance.", 'Champs obligatoires');
      return;
    }

    const payload = this.trajetZonesForm.getRawValue();
    if (!payload.zoneDepartId || !payload.zoneDestinationId) {
      this.toastService.erreur("Sélectionnez la zone de départ et la zone d'arrivée.", 'Champs obligatoires');
      return;
    }
    if (payload.zoneDepartId === payload.zoneDestinationId) {
      this.toastService.erreur("La zone de départ et la zone de destination doivent être différentes.", 'Zones identiques');
      return;
    }
    if (payload.distanceKm == null || payload.distanceKm <= 0) {
      this.toastService.erreur("La distance doit être un nombre positif.", 'Champs obligatoires');
      return;
    }

    this.chargement = true;

    if (this.estModeEdition) {
      this.trajetZonesService.modifierTrajet(payload).subscribe(
        (response) => {
          this.chargement = false;
          this.toastService.succes('Trajet modifié avec succès');
          this.router.navigate(['trajet/lister']);
        },
        (error) => {
          this.chargement = false;
          this.toastService.erreur(this.messageService.afficherMessageErreur(error));
        }
      );
    } else {
      delete (payload as any).id; // le DTO de création n’attend pas d’id

      this.trajetZonesService.enregistrerTrajet(payload).subscribe(
        (response) => {
          this.chargement = false;
          this.toastService.succes('Trajet enregistré avec succès');
          this.router.navigate(['trajet/lister']);
        },
        (error) => {
          this.chargement = false;
          this.toastService.erreur(this.messageService.afficherMessageErreur(error));
        }
      );
    }
  }

  
}
